import React from "react";
import { Col, Row } from "reactstrap";
import backIcon from "../assets/img/backIcon.svg";
import backIconDark from "../assets/img/backIconDark.svg";
import bell from "../assets/img/bell.svg";
import bellDark from "../assets/img/bellDark.svg";
import cartDark from "../assets/img/cartDark.png";
import cart from "../assets/img/cart.png";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getRestaurantsAction } from "../store/actions/restaurantsAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { addCartDetails } from "../store/actions/cartAction";

const MainNavigation = ({ title }) => {
  const location = useLocation();
  const history = useHistory();
  const pathname = location.pathname;
  const dispatch = useDispatch();
  const { cartDetails } = useSelector((state) => state.cart);
  const { darkMode } = useSelector((state) => state.global);
  const restaurantId = cartDetails?.restaurantId;
  const { orderTracker } = useSelector((state) => state.restaurants);
  const searchParams = new URLSearchParams(window.location.search);

  const handleBackNavigation = () => {
    const { pathname } = window.location;
    const isTracking = searchParams.get("tracking") === "true";

    if (pathname === "/restaurants") return window.location.replace("/main");
    if (pathname.startsWith("/restaurant/"))
      return window.location.replace("/restaurants");
    if (pathname.startsWith("/restaurant-details/")) {
      return (window.location.href = `/restaurant/${restaurantId}`);
    }
    if (pathname.startsWith("/tracking/orderID")) {
      if (isTracking) {
        return history.replace("/order-history");
      } else {
        const id =
          orderTracker?.restaurantID || localStorage.getItem("restaurantId");
        if (id) {
          dispatch(addCartDetails({ restaurantId: id }));
          localStorage.setItem("restaurantId", id);
          dispatch(getRestaurantsAction(id));
          setTimeout(() => {
            history.replace(`/order-options`);
          }, 1000);
          return;
        } else {
          return history.replace(`/restaurants`);
        }
      }
    }
    history.goBack();
  };

  return (
    <Row className="d-flex justify-content-center align-items-center">
      <Col className="col-3 col-md-2">
        <img
          alt="backIcon"
          className="cursor-pointer"
          src={darkMode ? backIconDark : backIcon}
          onClick={handleBackNavigation}
        />
      </Col>
      <Col className="col-6 d-flex justify-content-center">
        <h4
          className={
            darkMode
              ? "fs--25 fw--600 mb-0 normal-heading-dark"
              : "fs--25 fw--600 mb-0 normal-heading"
          }
        >
          {title || ""}
        </h4>
      </Col>
      {pathname === "/table" || pathname === "/comparison" ? (
        <Col className="col-2 col-md-3 d-flex justify-content-end">
          <div>
            <img
              src={darkMode ? cartDark : cart}
              alt="cart"
              className="mx-2 table__icons"
            />
            <img
              src={darkMode ? bellDark : bell}
              alt="bell"
              className="mx-2 table__icons"
            />
          </div>
        </Col>
      ) : (
        <Col className="col-2"></Col>
      )}
    </Row>
  );
};

export default MainNavigation;
